export enum SortKey {
  MANUAL = "MANUAL",
  BEST_SELLING = "BEST_SELLING",
  TITLE = "TITLE",
  PRICE = "PRICE",
  CREATED = "CREATED",
}

export type SortOptionKey =
  | "featured"
  | "best-selling"
  | "title-asc"
  | "title-desc"
  | "price-asc"
  | "price-desc"
  | "created-asc"
  | "created-desc";

export interface SortOptionValue {
  sortKey: SortKey;
  reverse: boolean;
}

export const sortOptions: Record<SortOptionKey, SortOptionValue> = {
  featured: { sortKey: SortKey.MANUAL, reverse: false },
  "best-selling": { sortKey: SortKey.BEST_SELLING, reverse: false },
  "title-asc": { sortKey: SortKey.TITLE, reverse: false },
  "title-desc": { sortKey: SortKey.TITLE, reverse: true },
  "price-asc": { sortKey: SortKey.PRICE, reverse: false },
  "price-desc": { sortKey: SortKey.PRICE, reverse: true },
  "created-asc": { sortKey: SortKey.CREATED, reverse: false },
  "created-desc": { sortKey: SortKey.CREATED, reverse: true },
} as const;

export const isValidSortOption = (key: string): key is SortOptionKey => {
  return key in sortOptions;
};

export const getSortOptionValue = (key: SortOptionKey): SortOptionValue => {
  return sortOptions[key];
};
